import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from "routes/private/Editor/Context";
import {ShapeObjectIcon} from '@assets/icons/shapeObjectIcon';
import ToolTip from '@components/Tooltip';

const ShapeTool:React.FC<IProps> = (props) => {
  let context = useContext(Context);
  
  const handleOpenNewShape = () => {  
    const picker = (context.editorStatus.currentPicker==="AddNewShape")?undefined:"AddNewShape";
    context.onShowPicker(picker);
  }
  
  return (
    <S.Root>
      <S.IconContainer
        onClick={handleOpenNewShape}
      >
        <ToolTip
          tip="Add Shape"
          boxStyle={{
            top: `0px`,
            left: `30px`,
            right: `auto`,
            width: `140px`,
            justifyContent: `start`
          }} 
        >
          <ShapeObjectIcon 
            style={{fillColor: (context.editorStatus.currentPicker==="AddNewShape") ? C.WHITE : undefined}}
          />
        </ToolTip>
      </S.IconContainer>
    </S.Root>
  );
}

export default ShapeTool;